(function() {
  // app下阻止加载快牛插件
  function getCookie(c_name) {
    if (document.cookie.length > 0) {
        var name = document.cookie.match(new RegExp('(^|)' + c_name + '=([^;])*', 'gi'))
        return (!name ? '' : name[0].split(c_name + '=')[1])
    }
    return ""
  }
  const conditions = [
  getCookie('appkey')?.includes('botslab'),
  /360Bostlab/i.test(navigator.userAgent)
  ]
  if(conditions.some(Boolean)){
  // 在app里执行如下
  function openCustomerServiceAndHideChat() {
      if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
      window.flutter_inappwebview.callHandler('getOverSeaConfig')
          .then(function(result) {
          if (result === true) {
              hideQuickChatIframe();
          }
          })
          .catch(function(error) {
          });
      } else {
      }
  }
  function hideQuickChatIframe() {
      const originalCreateElement = document.createElement;
      document.createElement = function(tagName) {
      const element = originalCreateElement.call(this, tagName);
      
      if (tagName.toLowerCase() === 'script') {
          Object.defineProperty(element, 'src', {
              set: function(value) {
                  if (value && typeof value === 'string' && value.includes('quickcep.com')) {
                      this._src = 'about:blank'; // 设置为空
                      return;
                  }
                  this._src = value;
              },
              get: function() {
                  return this._src;
              }
          });
      }
      
      return element;
      };
  }
  // 检查是否需要隐藏聊天框
  openCustomerServiceAndHideChat();
  }
})()